import { useMemo, useState } from 'react';
import { EnrollResponseDataType } from 'types';

function useEnrollResponse() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedData, setSelectedData] =
    useState<EnrollResponseDataType | null>(null);

  const isOn = useMemo(
    () => isOpen && selectedData !== null,
    [isOpen, selectedData],
  );

  const handleOpen = (data: EnrollResponseDataType) => {
    setSelectedData(data);
    setIsOpen(true);
  };

  const handleClose = () => {
    setSelectedData(null);
    setIsOpen(false);
  };

  return { isOn, handleOpen, handleClose, selectedData };
}

export default useEnrollResponse;
